import { Component, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { SheetModule } from '@valk-nx/components/ui-sheet/src';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	selector: `vp-filter-button`,
	templateUrl: './filter-button.html',
	imports: [SVG_ICON_IMPORTS, SheetModule, TranslatePipe],
})
export class FilterButtonComponent {
	label = input.required<string>();
	openable = input<boolean>(false);
	iconLeading = input<string | undefined>(undefined);
	indicator = input<number | undefined>(undefined);
	numberOfResults = input<number | undefined>(undefined);

	filterClick = output();

	handleClick() {
		if (!this.openable()) {
			this.filterClick.emit();
		}
	}
}
